import { useEffect, useState } from "react";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { TextField } from "@mui/material";

function ProgrammeList() {
  const { logout } = StaffuseAuth();

  const [ProgrammesYear, setProgrammesYear] = useState("Programmes_2025");

  const [data, setdata] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Lookups", ProgrammesYear, setdata, logout);
  }, [ProgrammesYear]);

  let props = [
    "Title",
    "Dates",
    "Varient",
    "Type",
    "Length",
    "Accom",
    "Airport",
    "UCAS",
    "Age",
    "BursaryPlaces",
    "Closed",
    "Capacity",
  ];

  const [Status, setStatus] = useState(false);
  function handleClose(e, programme, Choice) {
    e.preventDefault();
    console.log(programme);
    Update_To_MongoDB_By_ID(
      { Closed: Choice },
      "Lookups",
      ProgrammesYear,
      setStatus,
      programme._id,
      logout
    );
    //Update the data to show the programme is closed
    setdata((prevData) =>
      prevData.map((item) =>
        item._id === programme._id ? { ...item, Closed: Choice } : item
      )
    );
  }

  const [FilterEverything, setFilterEverything] = useState("");
  const handleFilterEverything = (e) => {
    setFilterEverything(e.target.value);
  };
  console.log("FilterEverything", FilterEverything);
  const dataFiltered = data.filter((Programme) => {
    return FilterEverything.split(" ").every((word) => {
      return Object.values(Programme).some((value) => {
        if (typeof value === "object") {
          return Object.values(value).some((value2) => {
            return value2.toString().toLowerCase().includes(word.toLowerCase());
          });
        }
        return value.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  //order data by alphabetical order for "Type" first, then "Title, then "Varient"
  dataFiltered.sort((a, b) => {
    if (a.Age.toLowerCase() < b.Age.toLowerCase()) {
      return -1;
    }
    if (a.Age.toLowerCase() > b.Age.toLowerCase()) {
      return 1;
    }
    if (a.Type.toLowerCase() < b.Type.toLowerCase()) {
      return -1;
    }
    if (a.Type.toLowerCase() > b.Type.toLowerCase()) {
      return 1;
    }
    if (a.Title.toLowerCase() < b.Title.toLowerCase()) {
      return -1;
    }
    if (a.Title.toLowerCase() > b.Title.toLowerCase()) {
      return 1;
    }
    if (a.Dates.toLowerCase() < b.Dates.toLowerCase()) {
      return -1;
    }
    if (a.Dates.toLowerCase() > b.Dates.toLowerCase()) {
      return 1;
    }
    if (a.Varient.toLowerCase() < b.Varient.toLowerCase()) {
      return -1;
    }
    if (a.Varient.toLowerCase() > b.Varient.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  return (
    <div>
      <DisplayExport excelData={data} fileName="Programmes_2025" />
      <h1>Programme List</h1>
      <h2>Programmes Year: {ProgrammesYear}</h2>
      <h3>Programmes Count: {data.length}</h3>
      <label htmlFor="programmesYear">Select Year: </label>
      <select
        id="programmesYear"
        value={ProgrammesYear}
        onChange={(e) => setProgrammesYear(e.target.value)}
      >
        <option value="Programmes_2025">2024/25</option>
        <option value="Programmes_2026">2025/26</option>
      </select>
      <br></br>
      <br></br>
      <TextField
        id="FilterEverything"
        label="Filter Everything"
        variant="outlined"
        value={FilterEverything}
        onChange={handleFilterEverything}
        fullWidth
        sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
      />
      <br></br>
      <br></br>
      <table>
        <thead>
          <tr>
            {props.map((prop, index) => (
              <th key={index}>{prop}</th>
            ))}
            <th key={"Button"}>Close/Open</th>
          </tr>
        </thead>
        <tbody>
          {dataFiltered.map((programme, index) => (
            <tr key={index}>
              {props.map((prop, index) => (
                <td key={index}>{programme[prop]}</td>
              ))}
              <td key={"Button"}>
                {programme.Closed === "Yes" ? (
                  <button
                    onClick={(e) => handleClose(e, programme, "No")}
                    style={{ backgroundColor: "red" }}
                  >
                    Closed, Click to Open
                  </button>
                ) : (
                  <button
                    onClick={(e) => handleClose(e, programme, "Yes")}
                    style={{ backgroundColor: "green" }}
                  >
                    Open, Click to Close
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProgrammeList;
